<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.5,785.66L0.5,785.66c0.76,0,1.37,0.61,1.37,1.37l0,0c0,0.76-0.61,1.37-1.37,1.37l0,0c-0.76,0-1.37-0.61-1.37-1.37l0,0
	C-0.87,786.27-0.26,785.66,0.5,785.66L0.5,785.66z M-3.53,787.63L-3.53,787.63C-3.53,787.63-3.53,787.63-3.53,787.63
	c0.84,0,1.52,0.68,1.52,1.52c0,0,0,0,0,0l0,0c0,0.84-0.68,1.52-1.52,1.52c0,0,0,0,0,0l0,0c-0.84,0-1.52-0.68-1.52-1.52l0,0
	c0,0,0,0,0,0C-5.05,788.31-4.37,787.63-3.53,787.63L-3.53,787.63z M4.53,787.63L4.53,787.63c0.84,0,1.52,0.68,1.52,1.52c0,0,0,0,0,0
	l0,0c0,0.84-0.68,1.52-1.52,1.52l0,0c0,0,0,0,0,0c-0.84,0-1.52-0.68-1.52-1.52l0,0c0,0,0,0,0,0C3,788.31,3.69,787.63,4.53,787.63
	C4.53,787.63,4.53,787.63,4.53,787.63L4.53,787.63z M0.5,789.93L0.5,789.93c0.93,0,1.69,0.76,1.69,1.69l0,0
	c0,0.93-0.76,1.69-1.69,1.69l0,0c-0.93,0-1.69-0.76-1.69-1.69l0,0C-1.19,790.69-0.43,789.93,0.5,789.93L0.5,789.93z M-7.81,790.01
	c0.93,0,1.69,0.76,1.69,1.69l0,0c0,0.93-0.76,1.69-1.69,1.69l0,0c-0.93,0-1.69-0.76-1.69-1.69l0,0
	C-9.5,790.77-8.74,790.01-7.81,790.01L-7.81,790.01z M8.81,790.01c0.93,0,1.69,0.76,1.69,1.69l0,0c0,0.93-0.76,1.69-1.69,1.69l0,0
	c-0.93,0-1.69-0.76-1.69-1.69l0,0C7.12,790.77,7.87,790.01,8.81,790.01L8.81,790.01z M-4.06,792.6
	C-4.06,792.6-4.06,792.6-4.06,792.6c1.04,0,1.88,0.84,1.88,1.88c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,1.04-0.84,1.88-1.88,1.88
	c0,0,0,0,0,0l0,0c-1.04,0-1.88-0.84-1.88-1.88c0,0,0,0,0,0l0,0c0,0,0,0,0,0C-5.94,793.44-5.1,792.6-4.06,792.6L-4.06,792.6z
	 M5.06,792.6c1.04,0,1.88,0.84,1.88,1.88c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,1.04-0.84,1.88-1.88,1.88l0,0c0,0,0,0,0,0
	c-1.04,0-1.88-0.84-1.88-1.88c0,0,0,0,0,0l0,0c0,0,0,0,0,0C3.18,793.44,4.02,792.6,5.06,792.6C5.06,792.6,5.06,792.6,5.06,792.6
	L5.06,792.6z M0.5,795.17L0.5,795.17L0.5,795.17c1.15,0,2.08,0.93,2.08,2.08l0,0l0,0c0,1.15-0.93,2.08-2.08,2.08h0l0,0h0
	c-1.15,0-2.08-0.93-2.08-2.08l0,0l0,0C-1.58,796.1-0.65,795.17,0.5,795.17L0.5,795.17L0.5,795.17z"/>
</svg>

</template>